// Iterates over Google Map API's result for geocoded place and returns the
// value of the component with name matching the fields argument.
// If multiple components match the fields, the value from the last one is returned.
// Arguments:
//    components: google.maps.places.PlaceResult Google Map API object
//    fields: this can either be
//      - the name of a single component being searched
//      - an array with multiple possible component names. The value of the last component found that matches
//        any of the items in the array will be returned
//    longName: a boolean indicating if long_name or short_name of the component should be returned
export default function(components, fields, longName) {
  let componentValue = null

  components.forEach((component) => {
    component.types.forEach((componentType) => {
      let included = false

      if (Array.isArray(fields)) {
        included = fields.includes(componentType)
      } else {
        included = componentType === fields
      }

      if (included) {
        componentValue = longName ? component.long_name : component.short_name
      }
    })
  })

  return componentValue
}
